'use client';

import { useEffect } from 'react';

const HISTORY_NAVIGATION_GRACE_MS = 1000;

let lastHistoryNavigationAt = Number.NEGATIVE_INFINITY;

if (globalThis.window !== undefined) {
  globalThis.addEventListener('popstate', () => {
    lastHistoryNavigationAt = performance.now();
  });
}

export const ScrollToTopOnEnter = () => {
  useEffect(() => {
    if (performance.now() - lastHistoryNavigationAt < HISTORY_NAVIGATION_GRACE_MS) return;
    globalThis.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return null;
};
